"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RelatedIdeasList = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _connectors = require("@insided/shared/services/algolia/connectors");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var RelatedIdeasList = function RelatedIdeasList(props) {
  var _props$hits = props.hits,
      hits = _props$hits === void 0 ? [] : _props$hits,
      topicId = props.topicId,
      totalItemCount = props.totalItemCount;
  var hitsWithoutCurrent = hits.filter(function (hit) {
    return hit.id !== parseInt(topicId);
  }).slice(0, totalItemCount);

  if (!hitsWithoutCurrent.length) {
    return null;
  }

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('box__content', 'widget', 'box__pad', 'widget--related-ideas')
  }, (0, _preact.h)("h3", {
    className: "widget-title related-ideas__widget-title"
  }, (0, _preact.h)(_phrase.default, {
    p: "related.ideas.title"
  })), (0, _preact.h)("ul", {
    className: "simple-topic-list"
  }, hitsWithoutCurrent.map(function (hit, index) {
    return (0, _preact.h)("li", {
      key: index,
      className: "related-ideas__topic simple-topic-list--item"
    }, (0, _preact.h)("h6", {
      className: "related-ideas__topic-title simple-topic-list--title"
    }, (0, _preact.h)("a", {
      className: "link link--topic",
      href: (0, _absoluteUrlRuntime.resolveUrl)(hit.topic_url)
    }, _htmlParser.default.stripHtml(hit.title))));
  })));
};

exports.RelatedIdeasList = RelatedIdeasList;
var RelatedTopicsListContainer = (0, _connectors.connectHits)(RelatedIdeasList);
var _default = RelatedTopicsListContainer;
exports.default = _default;